const DEFAULT_CACHE_CONTROL = 'no-cache, no-store, must-revalidate';
const CV_CACHE_CONTROL = 'public, max-age=3600';
const CV_MAX_AGE_MS = 3600 * 1000;

const set_http_equiv_meta = (http_equiv, content) => {
  const selector = `meta[http-equiv="${http_equiv}" i]`;
  let el = document.querySelector(selector);

  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('http-equiv', http_equiv);
    document.head.appendChild(el);
  }

  el.setAttribute('content', content);
};

/** Soft-cache CV pages for 1 hour (colleague request: avoid frequent reloads). */
export const enable_cv_page_cache_control = () => {
  set_http_equiv_meta('cache-control', CV_CACHE_CONTROL);
  set_http_equiv_meta('pragma', 'cache');
  set_http_equiv_meta(
    'expires',
    new Date(Date.now() + CV_MAX_AGE_MS).toUTCString()
  );
};

/** Restore global SPA defaults from index.html when leaving a CV page. */
export const disable_cv_page_cache_control = () => {
  set_http_equiv_meta('cache-control', DEFAULT_CACHE_CONTROL);
  set_http_equiv_meta('pragma', 'no-cache');
  set_http_equiv_meta('expires', '0');
};
